export default __webpack_public_path__ + "static/media/election2020primary.f91a3e5b.txt";